import { render, staticRenderFns } from "./ProcessReportUnlockDocument.vue?vue&type=template&id=4efd8b2d&scoped=true&"
import script from "./ProcessReportUnlockDocument.vue?vue&type=script&lang=js&"
export * from "./ProcessReportUnlockDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd8b2d",
  null
  
)

export default component.exports